import { createContext, useContext, useEffect, useState } from "react";
import { ScrapedEditProductDrawer } from "../components/Products/ScrapedEditProductDrawer";

import { ToastContainer } from "react-toastify";

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
	const [data, setData] = useState([]);
	const [product, setProduct] = useState(null);
	const [editOpen, setEditOpen] = useState(false);
	const [edit, setEdit] = useState(false);
	useEffect(() => {
		if (!editOpen) {
			setProduct(null);
		}
	}, [editOpen]);

	const handleAddProduct = () => {
		setProduct(null);
		setEdit(false);
		setEditOpen(true);
	};
	const handleEditProduct = (item) => {
		console.log("====================================");
		console.log("handleEditProduct", item);
		console.log("====================================");
		setProduct(item);
		console.log(item);
		setEdit(true);
		setEditOpen(true);
	};

	return (
		<ProductContext.Provider
			value={{
				data,
				setData,
				product,
				setProduct,
				editOpen,
				setEditOpen,
				handleEditProduct,
				handleAddProduct,
			}}
		>
			<ToastContainer />
			{children}

			<ScrapedEditProductDrawer
				editOpen={editOpen}
				setEditOpen={setEditOpen}
				edit={edit}
				setProducts={setData}
				fromGroup={false}
				product={product}
			/>
		</ProductContext.Provider>
	);
};

export const useProductContext = () => {
	const context = useContext(ProductContext);
	if (!context) {
		throw new Error(
			"useProductContext must be used inside a ProductProvider"
		);
	}
	return context;
};
